<mat-card data-at-firmware-update-modal>
  <mat-card-header>
    <mat-card-title>
      {{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <ng-container>
      <div class="flex flex-col gap-3 justify-center items-center">
        <img src="assets/img/up-to-date.svg" />
        <p>
          {{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.FIRMWARE_UP_TO_DATE' | translate }}
        </p>
      </div>
    </ng-container>
  </mat-card-content>

  <mat-card-actions
    class="flex flex-row lt-md:flex-col gap-[10px] justify-end items-center lt-md:justify-start text-end"
  >
    <button
      data-at-firmware-update-modal-close
      mat-raised-button
      color="primary"
      class="fill-btn"
      gtm="onCancelDialog"
      gtmCategory="firmwareUpdate"
      gtmAction="Close firmware update modal"
      (click)="onClose()"
    >
      {{ 'GENERAL.BUTTON.CLOSE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
